<div *ngIf="currentRfqStep === 1" class="!mt-[-46px]">
  <div
    class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] bg-[#F1F3F5]"
  >
    <p class="!m-0 pl-[20px]">{{ projectName }} -Request for Quotation (RFQ)</p>
    <p
      class="!mt-[10px] bg-white !ml-[15px] flex items-center justify-center tag"
    >
      Project Brief
    </p>
  </div>
  <div class="p-[21px] !pb-0">
    <app-brief-section></app-brief-section>
  </div>
  <div
    class="relative bottom-0 right-0 !pr-[40px] !mb-[60px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="nextStep()"
      >
        Next
      </button>
    </div>
  </div>
</div>
<div *ngIf="currentRfqStep === 2">
  <!-- we need isEdit on just the first as we create row only in this. in rest we just update it so its already edit -->
  <app-rfq-work-packages
    [isEdit]="isEdit"
    [ITTDeveloperData]="ITTDeveloperData"
    (workPackagesDataEmitter)="handleWorkPackagesData($event)"
  ></app-rfq-work-packages>
</div>
<div *ngIf="currentRfqStep === 3">
  <app-rfq-companies-selection
    [ITTDeveloperData]="ITTDeveloperData"
    (companiesSelectionDataEmitter)="handleCompaniesSelectionData($event)"
  ></app-rfq-companies-selection>
</div>
<div *ngIf="currentRfqStep === 4">
  <app-rfq-tender-submission-guidlines
    [ITTDeveloperData]="ITTDeveloperData"
    (tenderSubmissionDataEmitter)="handleTenderSubmissionData($event)"
  ></app-rfq-tender-submission-guidlines>
</div>
<div *ngIf="currentRfqStep === 5">
  <app-rfq-contractual-terms
    [ITTDeveloperData]="ITTDeveloperData"
    (contractualTermsDataEmitter)="handlecontractualTermsData($event)"
  ></app-rfq-contractual-terms>
</div>
<div *ngIf="currentRfqStep === 6">
  <app-rfq-key-dates
    [ITTDeveloperData]="ITTDeveloperData"
    (keyDatesDataEmitter)="handlekeyDatesData($event)"
  ></app-rfq-key-dates>
</div>
